export default "__VITE_ASSET__C0cOw$4t__"